import { render, staticRenderFns } from "./DraggableContent.vue?vue&type=template&id=1d4baa40&scoped=true&"
import script from "./DraggableContent.vue?vue&type=script&lang=js&"
export * from "./DraggableContent.vue?vue&type=script&lang=js&"
import style0 from "./DraggableContent.vue?vue&type=style&index=0&id=1d4baa40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4baa40",
  null
  
)

export default component.exports